import { InboxEntry } from '~/storm'

export const toInboxEntryData = (entry: InboxEntry) => ({
    entryId: entry.id,
    inboxType: entry.inbox_type,
    sourceType: entry.source.attribute_type,
    subjectType: entry.subject_type,
})
